// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"22fe0a28","257":"bcc7b215","478":"d8f55e23","606":"e3a699be","992":"1d702089"}[chunkId] + ".chunk.js";
};